import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './submission-request.reducer';

export const SubmissionRequestDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const submissionRequestEntity = useAppSelector(state => state.submissionRequest.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="submissionRequestDetailsHeading">
          <Translate contentKey="tycheApp.submissionRequest.detail.title">SubmissionRequest</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="global.field.id">ID</Translate>
            </span>
          </dt>
          <dd>{submissionRequestEntity.id}</dd>
          <dt>
            <span id="requestJson">
              <Translate contentKey="tycheApp.submissionRequest.requestJson">Request Json</Translate>
            </span>
          </dt>
          <dd>{submissionRequestEntity.requestJson}</dd>
          <dt>
            <span id="type">
              <Translate contentKey="tycheApp.submissionRequest.type">Type</Translate>
            </span>
          </dt>
          <dd>{submissionRequestEntity.type}</dd>
          <dt>
            <span id="ocrJson">
              <Translate contentKey="tycheApp.submissionRequest.ocrJson">Ocr Json</Translate>
            </span>
          </dt>
          <dd>{submissionRequestEntity.ocrJson}</dd>
          <dt>
            <span id="responseJson">
              <Translate contentKey="tycheApp.submissionRequest.responseJson">Response Json</Translate>
            </span>
          </dt>
          <dd>{submissionRequestEntity.responseJson}</dd>
          <dt>
            <Translate contentKey="tycheApp.submissionRequest.submission">Submission</Translate>
          </dt>
          <dd>{submissionRequestEntity.submission ? submissionRequestEntity.submission.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/submission-request" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/submission-request/${submissionRequestEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default SubmissionRequestDetail;
